export const SUBTRAMITES_CONFIG = {
  CATASTRAL: {
    key: "catastral",
    label: "Certificado Catastral",
    category: "certificados",
  },
  RESERVA: {
    key: "reserva",
    label: "Certificado reserva de prioridad",
    category: "certificados",
  },
  PLANO_MENSURA: {
    key: "planomensura",
    label: "Plano de mensura",
    category: "planos",
  },
  PLANO_DE_RELEVAMIENTO: {
    key: "planorelevamiento",
    label: "Plano de relevamiento",
    category: "planos",
  },
  ATM: {
    key: "atm",
    label: "Certificado ATM",
    category: "tramites",
  },
  MUNICIPALIDAD: {
    key: "municipalidad",
    label: "Certificado Municipal",
    category: "tramites",
  },
  VIALIDAD: {
    key: "vialidad",
    label: "Certificado de Vialidad",
    category: "tramites",
  },
  AGUAS: {
    key: "aguas",
    label: "Certificado de Aguas",
    category: "tramites",
  },
  EXPENSAS: {
    key: "expensas",
    label: "Certificado de Expensas",
    category: "tramites",
  },
  IRRIGACION: {
    key: "irrigacion",
    label: "Certificado de Irrigación",
    category: "tramites",
  },
  ESTUDIO_RESULTADO: {
    key: "estudiotitulo",
    label: "Resultado",
    category: "estudio-titulo",
  },

  CERTIFICADOS_OTRO: {
    selector: (tramite) => tramite.otros?.find(o => o.categoria === "certificados"),
    label: (subtramite) => subtramite?.nombre || "Otro (Certificado)",
    category: "certificados",
  },
  PLANOS_OTRO: {
    selector: (tramite) => tramite.otros?.find(o => o.categoria === "planos"),
    label: (subtramite) => subtramite?.nombre || "Otro (Plano)",
    category: "planos",
  },
  TRAMITES_OTRO: {
    selector: (tramite) => tramite.otros?.find(o => o.categoria === "tramites"),
    label: (subtramite) => subtramite?.nombre || "Otro (Trámite)",
    category: "tramites",
  },
  ESTUDIO_TITULO_OTRO: {
    selector: (tramite) => tramite.otros?.find(o => o.categoria === "estudio-titulo"),
    label: (subtramite) => subtramite?.nombre || "Otro (Estudio de Título)",
    category: "estudio-titulo",
  },
}
